var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArmPowerTripleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "armPowerTripleIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 685",
    fill: "none",
    d: "M0 0h72v72H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#040000",
    clipPath: "url(#armPowerTripleIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1044",
    d: "M18.099 66.702L6.89 41.16l.415-3 15.853-11.95 1.963-.06.269-5.633-2.491.124-1.5.617L2.982 35.241l-1.114 6.6 11.46 25.361 7.122 2.339c.211.188.525.02.7-.375.154-.343.118-.19-.033-.415z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1045",
    d: "M54.272 66.702l11.2-25.545-.415-3L49.213 26.21l-1.963-.06-.268-5.633 2.491.124 1.5.617 18.415 13.983 1.114 6.6-11.46 25.361-7.122 2.339c-.211.188-.525.02-.7-.375-.154-.343-.118-.19.033-.415z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1046",
    d: "M18.099 66.702L6.89 41.16l.415-3 15.853-11.95 1.963-.06.269-5.633-2.491.124-1.5.617L2.982 35.241l-1.114 6.6 11.46 25.361 7.122 2.339c.211.188.525.02.7-.375.154-.343.118-.19-.033-.415z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1047",
    d: "M54.272 66.702l11.2-25.545-.415-3L49.213 26.21l-1.963-.06-.268-5.633 2.491.124 1.5.617 18.415 13.983 1.114 6.6-11.46 25.361-7.122 2.339c-.211.188-.525.02-.7-.375-.154-.343-.118-.19.033-.415z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1048",
    d: "M34.952 65.466c.1.171.593.3 1.219.3s1.123-.133 1.219-.3l.412-4.356-.183-20.979.485-10.667h-3.839l.486 10.667-.2 20.979"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1049",
    d: "M34.952 65.466c.1.171.593.3 1.219.3s1.123-.133 1.219-.3l.412-4.356-.183-20.979.485-10.667h-3.839l.486 10.667-.2 20.979"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1050",
    d: "M40.045 67.31c0 1.2-1.727 2.174-3.858 2.174s-3.858-.973-3.858-2.174 1.727-5.2 3.858-5.2 3.858 4 3.858 5.2"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1051",
    d: "M36.186 24.905a9.125 9.125 0 10-9.122-9.124 9.135 9.135 0 009.125 9.125"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1052",
    d: "M16.313 15.575c0 6.73 2.9 13.545 8.372 16.7h23c5.475-3.15 8.373-9.965 8.373-16.7A19.24 19.24 0 0048.388.253h-24.4a19.246 19.246 0 00-7.675 15.322M36.186 4.647a11.133 11.133 0 11-11.134 11.135A11.146 11.146 0 0136.186 4.647"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1053",
    d: "M36.186 24.905a9.125 9.125 0 10-9.122-9.124 9.135 9.135 0 009.125 9.125"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1054",
    d: "M16.313 15.575c0 6.73 2.9 13.545 8.372 16.7h23c5.475-3.15 8.373-9.965 8.373-16.7A19.24 19.24 0 0048.388.253h-24.4a19.246 19.246 0 00-7.675 15.322M36.186 4.647a11.133 11.133 0 11-11.134 11.135A11.146 11.146 0 0136.186 4.647"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1055",
    d: "M18.099 66.702L6.89 41.16l.415-3 15.853-11.95 1.963-.06.269-5.633-2.491.124-1.5.617L2.982 35.241l-1.114 6.6 11.46 25.361 7.122 2.339c.211.188.525.02.7-.375.154-.343.118-.19-.033-.415z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1056",
    d: "M54.272 66.702l11.2-25.545-.415-3L49.213 26.21l-1.963-.06-.268-5.633 2.491.124 1.5.617 18.415 13.983 1.114 6.6-11.46 25.361-7.122 2.339c-.211.188-.525.02-.7-.375-.154-.343-.118-.19.033-.415z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1057",
    d: "M34.952 65.466c.1.171.593.3 1.219.3s1.123-.133 1.219-.3l.412-4.356-.183-20.979.485-10.667h-3.839l.486 10.667-.2 20.979"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1058",
    d: "M36.186 24.905a9.125 9.125 0 10-9.122-9.124 9.135 9.135 0 009.125 9.125"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1059",
    d: "M16.313 15.575c0 6.73 2.9 13.545 8.372 16.7h23c5.475-3.15 8.373-9.965 8.373-16.7A19.24 19.24 0 0048.388.253h-24.4a19.246 19.246 0 00-7.675 15.322M36.186 4.647a11.133 11.133 0 11-11.134 11.135A11.146 11.146 0 0136.186 4.647"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmPowerTripleIcon);
export default __webpack_public_path__ + "static/media/armPowerTripleIcon.00ef1fe67bd055ca.svg";
export { ForwardRef as ReactComponent };